import { mapCollection } from '../../utils/collection.utils';
import { CamTool } from '../cam-tool';
import { CamToolHolder } from '../cam-tool-holder';

export class CamToolBuilder {
  static fromJson(json) {
    return (json)
      ? new CamTool(
        json.hash,
        json.name
      )
      : null;
  }

  static fromList(list) {
    return mapCollection(CamToolBuilder.fromJson, list);
  }

  static buildCamToolHolderFromJson(json) {
    return (json)
      ? new CamToolHolder(
        json.hash,
        json.name
      )
      : null;
  }

  static buildCamToolHolderFromList(list) {
    return mapCollection(CamToolBuilder.buildCamToolHolderFromJson, list);
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/cam-tool.builder.ts